
export default function useActions(
  quantity, setSelectedSeats, selectedSeats, holdSeat, releaseSeat
) {

  // Tope de selección = cantidad elegida en el stepper. Se lee del input REAL de
  // WooCommerce en el momento del click, NO del estado `quantity` de React. Motivo:
  // el tema (Porto) incrementa/decrementa el input sin disparar eventos
  // 'input'/'change', y el usuario puede fijar la cantidad ANTES de que monte el
  // selector. En ambos casos el estado de React se desincroniza (queda en 1 mientras
  // el input muestra 2), lo que hacía que solo se pudiera elegir 1 butaca. Leer el
  // DOM al momento de decidir elimina ese desfase de raíz. `quantity` (prop) queda
  // como fallback si el input no estuviera disponible.
  const readCap = () => {
    const input     = document.querySelector('input[name="quantity"]');
    const fromInput = input ? Number(input.value) : NaN;
    if (Number.isFinite(fromInput) && fromInput >= 1) return Math.floor(fromInput);

    const fromProp = Number(quantity);
    return Number.isFinite(fromProp) && fromProp >= 1 ? Math.floor(fromProp) : 1;
  };

  const handleSelectSeat = (seatNumber) => {
    const isSelected = selectedSeats.includes(seatNumber);

    if (isSelected) {
      // Deseleccionar: liberar el hold y quitar de la selección.
      releaseSeat(seatNumber);
      setSelectedSeats((prev) => prev.filter((s) => s !== seatNumber));
    } else {
      const cap = readCap();
      if (selectedSeats.length >= cap) {
        // Al llegar al tope, clickear una butaca nueva CAMBIA de ubicación: libera
        // la primera seleccionada y toma la nueva (swap). Es visible (la vieja se
        // deselecciona, la nueva se selecciona) y mantiene el conteo en el tope, así
        // que nunca se sobre-selecciona ni se bloquea inventario de más.
        //
        // Este swap ya NO es el que causaba la pérdida silenciosa: el recorte
        // AUTOMÁTICO por cambio de `quantity` (slice(-quantity) en un useEffect) fue
        // eliminado, y el submit envía la cantidad = nº de asientos seleccionados,
        // así que el precio siempre coincide con las butacas (sin descalce).
        const [seatToRelease, ...rest] = selectedSeats;
        releaseSeat(seatToRelease);
        holdSeat(seatNumber);
        setSelectedSeats([...rest, seatNumber]);
      } else {
        holdSeat(seatNumber);
        setSelectedSeats((prev) => [...prev, seatNumber]);
      }
    }
  };


  return {
    handleSelectSeat
  };
}
